// extracted by mini-css-extract-plugin
export default {"wrapper":"BottomNavbar_wrapper__luet0"};